<template>
  <div>
    <Header>
      仕事をキャンセル
    </Header>

    <div class="application-cancel p-3">
      <CustomValidationObserver ref="vObserver" v-slot="{ handleSubmit }">
        <div class="rule-list" data-testid="cancel-caution">
          <div class="text-weight-500 text-red text-size-16 mt-2 mb-1 caution">
            <FeatherIcon
              icon="alert-triangle"
              size="18"
              class="caution-icon"
            />事業所担当者へ電話で連絡をせずキャンセルした場合、サービス一時利用停止となります
          </div>
        </div>

        <div class="contact-block" :class="contactBlockClass">
          <p class="text-size-14 text-weight-500 mt-2">
            事業所様に必ず事前に電話で連絡してください<br />
            現場の方々の負担を少しでも軽くするためにご協力ください。
          </p>
          <div v-if="officeInfo" class="text-center mt-2">
            <div
              class="contact-box text-left bg-white border border-outline-color round-4"
            >
              <p>事業所名：{{ officeInfo.name }}</p>
              <p>担当者：{{ officeInfo.staffName }}</p>
              <p>
                電話番号：<a
                  :href="'tel:' + officeInfo.phoneNumber"
                  class="text-blue"
                  >{{ officeInfo.phoneNumber }}</a
                >
              </p>
              <p v-if="officeInfo.emergencyContact" class="text-pre-wrap mt-2">
                {{ officeInfo.emergencyContact }}
              </p>
              <a :href="'tel:' + officeInfo.phoneNumber">
                <AppButton variant="green" :block="true" class="d-block mt-3"
                  >電話をする</AppButton
                >
              </a>
            </div>
          </div>
        </div>

        <div class="text-center my-4">
          <AppCheckbox
            v-model="isCheckedContacted"
            id="contacted"
            text="担当者に電話が繋がりキャンセルの承諾を得た"
            class="mt-2 cancel-check-box"
          />
          <div class="mt-1 text-size-12">
            (繋がらない場合は、時間帯を変更して電話してください)
          </div>
        </div>

        <AppButton
          :disabled="!isCheckedContacted"
          :block="true"
          variant="secondary"
          class="d-block mt-2 py-2"
          @click="handleSubmit(onClickSubmitButton)"
          >{{ buttonText }}
        </AppButton>
      </CustomValidationObserver>
    </div>
  </div>
</template>

<script lang="ts">
import { applicationService } from "@/app/services/ApplicationService";
import AppButton from "@/components/atoms/button/AppButton.vue";
import AppCheckbox from "@/components/atoms/input/AppCheckbox.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import Header from "@/components/organisms/common/Header.vue";
import { cancelRequestStore } from "@/store/cancel-request";
import { Application } from "@/types/order/Application";
import { ErrorType, showErrorModal } from "@/utils/showErrorModal";
import { Component, Vue } from "vue-facing-decorator";

@Component({
  components: {
    Header,
    AppButton,
    AppCheckbox,
    FeatherIcon
  }
})
export default class ApplicationCancel extends Vue {
  application: Application | null = null;
  isCheckedContacted = false;

  get applicationId() {
    return this.$route.params.applicationId;
  }

  get officeInfo() {
    return this.application?.order.office;
  }

  get buttonText() {
    return this.isCancelDueToInfection || this.isCheckedContacted
      ? "キャンセル完了"
      : "まだキャンセルは完了していません";
  }

  get cancelType() {
    return this.$route.query.cancelType;
  }

  get isCancelDueToInfection() {
    return this.cancelType === "infection";
  }

  get contactBlockClass() {
    return this.isCancelDueToInfection ? "" : "mt-4";
  }

  async created() {
    try {
      this.$loading.show();
      await this.fetchApplication();
    } catch (error) {
      showErrorModal(this, error as ErrorType);
    } finally {
      this.$loading.hide();
    }
  }

  onClickBack() {
    this.$router.back();
  }

  async onClickSubmitButton() {
    cancelRequestStore.clearPhoneCallApplicationId();
    cancelRequestStore.clearCancelType();
    await this.$bvModal.msgBoxOk("キャンセルが完了しました。", {
      centered: true
    });

    await this.$router.push({ name: "ApplicationsList" });
  }

  async fetchApplication() {
    this.application = await applicationService.fetchApplication(
      Number(this.applicationId)
    );
  }
}
</script>

<style lang="scss" scoped>
.application-cancel {
  .icon-area {
    line-height: 1;
  }

  .contact-box {
    padding: 24px;
  }
}

.rule-list {
  padding: 16px;
  font-size: 14px;
  background-color: $primary-bg;
  border: 1px solid $yellow;
  border-radius: 4px;

  &__text {
    margin-bottom: 0;
    margin-left: 26px;
    color: $mild;
  }
}

.caution {
  position: relative;
  padding-left: 26px;
}

.caution-icon {
  position: absolute;
  top: 4px;
  left: 0;
}

.cancel-check-box {
  :deep(span) {
    font-size: 14px !important;
    vertical-align: middle;
  }
}
</style>
